export const STATUS_ETAT_TRAITEMENTS_REQUESTING = 'status-etat-traitements/STATUS_ETAT_TRAITEMENTS_REQUESTING';
export const STATUS_ETAT_TRAITEMENTS_SUCCESS = 'status-etat-traitements/STATUS_ETAT_TRAITEMENTS_SUCCESS';
export const STATUS_ETAT_TRAITEMENTS_FAILED = 'status-etat-traitements/STATUS_ETAT_TRAITEMENTS_FAILED';
export const STATUS_ETAT_TRAITEMENTS_EDIT_REQUESTING = 'status-etat-traitements/STATUS_ETAT_TRAITEMENTS_EDIT_REQUESTING';
export const STATUS_ETAT_TRAITEMENTS_EDIT_SUCCESS = 'status-etat-traitements/STATUS_ETAT_TRAITEMENTS_EDIT_SUCCESS';
export const STATUS_ETAT_TRAITEMENTS_EDIT_FAILED = 'status-etat-traitements/STATUS_ETAT_TRAITEMENTS_EDIT_FAILED';

export const STATUS_ETAT_TRAITEMENTS_SET_DATA = 'status-etat-traitements/STATUS_ETAT_TRAITEMENTS_SET_DATA';
